<template>
	<div id="page">

		<!-- 页头 -->
		<pagehead ref="pagehead" />

		<!-- 占高盒 -->
		<div class="pager">
			<!-- 个人中心盒子 -->
			<div class="mineBox df dfsb w1k2 mauto">
				<!-- 左侧内容 -->
				<mineleft />
				<!-- 右侧内容 -->
				<div class="mineBoxR f1 ml25">
					<!-- 上面卡片 -->
					<el-tabs type="border-card">
						<el-tab-pane label="账户信息">
							<!-- 卡片内容 -->
							<template>
								<!-- 用户信息 -->
								<div class="userInfo plr10">
									<!-- 信息列表 -->
									<div class="userInfoList df">
										<div class="userInfoListL">用户名</div>
										<div class="userInfoListR">{{nickName? nickName : '未登录'}}</div>
									</div>
									<div class="userInfoList df">
										<div class="userInfoListL">用户等级</div>
										<div class="userInfoListR">{{level}}</div>
									</div>
									<div class="userInfoList df">
										<div class="userInfoListL">注册时间</div>
										<div class="userInfoListR">{{createTime}}</div>
									</div>
									<!-- 列表结束 -->
								</div>
							</template>
						</el-tab-pane>
					</el-tabs>

					<!-- 下面卡片 -->
					<el-container class="orderInfo w100p mt30 bw bs">
						<el-header>
							<!-- 标题 -->
							<div class="orderInfoTitle b">订单信息</div>
							<!-- 更多 -->
							<div class="orderInfoMore df aic cp">
								<el-button class="orderInfoMoreTxt" type="text" @click="history = true">查看历史订单</el-button>
								<!-- <div class="orderInfoMoreTxt">查看历史订单</div> -->
								<div class="orderInfoMoreImg ml10"><img class="img" src="../assets/minListMore.png">
								</div>
							</div>
						</el-header>
						<el-main>
							<!-- 表格 -->
							<div class="oITable">
								<div class="tr">
									<div class="th">订单ID</div>
									<div class="th">开始时间</div>
									<div class="th">结束时间</div>
									<div class="th">合同费用（元）</div>
									<div class="th">备注</div>
								</div>
								<div class="tr" v-if="orderList">
									<div class="td">{{orderList.orderId}}</div>
									<div class="td">{{orderList.starDate}}</div>
									<div class="td">{{orderList.endDate}}</div>
									<div class="td">{{orderList.cost}}</div>
									<div class="td">{{orderList.remark}}</div>
								</div>
								<div class="tr" v-if="!orderList">
									<div class="td f1 caaa">当前无数据</div>
								</div>
							</div>
						</el-main>
					</el-container>
				</div>
			</div>
		</div>

		<!-- 弹窗 历史订单 -->
		<el-dialog title="系统提示" :visible.sync="history">
			<div class="oITable w600 mlr40 c333">
				<div class="tr">
					<div class="th">订单ID</div>
					<div class="th">开始时间</div>
					<div class="th">结束时间</div>
					<div class="th">合同费用（元）</div>
					<div class="th">备注</div>
				</div>
				<div class="tr" v-for="(item,index) in orList" :key="index" v-if="orList.length != 0">
					<div class="td">{{item.orderId}}</div>
					<div class="td">{{item.starDate}}</div>
					<div class="td">{{item.endDate}}</div>
					<div class="td">{{item.cost}}</div>
					<div class="td">{{item.remark}}</div>
				</div>
				<div class="tr" v-if="orList.length == 0">
					<div class="td f1">当前无数据</div>
				</div>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="history = false">取 消</el-button>
				<el-button type="primary" @click="history = false">确 定</el-button>
			</span>
		</el-dialog>

		<!-- 页脚 -->
		<pagefoot />

	</div>
</template>
<script>
	// 全局变量
	var that;
	export default {
		// 页面变量
		data() {
			return {
				// 用户头像
				userphoto: require("../assets/userphoto.png"),
				// 弹窗提示内容
				history: false,
				// 用户名
				nickName: '未登录',
				// 等级
				level: '',
				// 注册时间
				createTime: '0000-00-00',
				// 历史订单
				orderList: [],
				// 全部历史订单
				orList: [],
			}
		},

		// 实例化后
		created() {
			
			that = this;

		},
		
		//	激活
		activated(){

			that.util.checkToken((res)=>{
				// 获取用户信息
				that.getuserInfo();
				// 获取订单
				that.getOrder();
				that.getOrderList();
				
			})
			
		},
		

		// 方法集
		methods: {

			// 获取用户信息
			getuserInfo() {
				// 用户名称
				that.nickName = '';
				// 用户等级
				that.level = '';
				// 注册时间
				that.createTime = '';
				
				// 用户名称
				that.nickName = localStorage.getItem('memberName');
				// 用户等级
				that.level = localStorage.getItem('memberLevelName');
				// 注册时间
				that.createTime = localStorage.getItem('createTime');
			},
			
			// 获取订单
			getOrderList(){
				// 请求接口 
				that.request({
					url: '/api/Order/selectOrderList',
					// 上传数据
					data:{
						// 用户id
						mmpMemberId: localStorage.getItem('memberId'),
						// 1：最近的一条的订单信息
						// 0：全部的订单
						lateDate: 1,
					},
					// 调用成功
					success(rs){
						// 返回成功
						if(rs.code == 200){
							that.orderList = rs.data;
						}else{
							//弹窗提示用户
							that.$message.error(rs.msg);
						}
					}
				})
			},
			
			// 获取订单
			getOrder(){
				// 请求接口 
				that.request({
					url: '/api/Order/selectOrderList',
					// 上传数据
					data:{
						// 用户id
						mmpMemberId: localStorage.getItem('memberId'),
						// 1：最近的一条的订单信息
						// 0：全部的订单
						lateDate: 0,
					},
					// 调用成功
					success(rs){
						// 返回成功
						if(rs.code == 200){
							that.orList = rs.data;
						}else{
							//弹窗提示用户
							that.$message.error(rs.msg);
						}
					}
				})
			},
			
			//	父组件接受子组件调用方法
			layout(){
				that.$refs.pagehead.clickUserphoto();
			},

		},
	};
</script>
<style>
	/* 左侧盒子 */
	.mineBoxL {
		width: 170px;
	}

	/* 用户头像 */
	.userPhoto {
		width: 36px;
		height: 36px;
	}

	/* 用户等级 */
	.userLevel {
		width: 46px;
		height: 18px;
	}

	/* 用户等级文字 */
	.userLevelTxt {
		right: 3px;
		line-height: 18px;
	}

	/* 左盒子列表 */
	.mineBoxLB ul li {
		display: flex;
		justify-content: space-between;
		padding: 15px 20px;
		text-indent: 20px;
		color: #333;
		font-size: 14px;
	}

	/* 左盒子列表更多箭头 */
	.mineBoxLB ul li .more {
		opacity: 0;
		transition: .2s;
	}

	/* 左侧盒子鼠标经过 */
	.mineBoxLB ul li:hover {
		color: #0066dd;
		background-color: #F6FAFF;
	}

	/* 左侧盒子鼠标经过更多箭头 */
	.mineBoxLB ul li:hover .more {
		opacity: 1;
	}

	/* 左侧盒子选中样式 */
	.mineBoxLB ul li.active {
		color: #0066dd;
		background-color: #F6FAFF;
	}

	/* 左盒子列表更多箭头 */
	.mineBoxLB ul li.active .more {
		opacity: 1;
	}

	/* 用户信息列表 */
	.userInfoList {
		align-items: center;
	}

	/* 用户信息列表左 */
	.userInfoListL {
		width: 100px;
		line-height: 40px;
	}

	/* 用户信息列表左右 */
	.userInfoListL,
	.userInfoListR {
		/* color: #666; */
		font-size: 14px;
	}

	/* 头部选项卡 */
	.mineBoxR .el-tabs__item {
		font-size: 16px;
		font-weight: bold;
		height: 60px;
		line-height: 60px;
	}

	/* 顶部选中样式 */
	.mineBoxR .el-tabs__item.is-top.is-active {
		color: #333;
	}

	/* 订单信息 */
	.orderInfo {
		min-height: 250px;
	}

	/* 订单信息头部 */
	.orderInfo .el-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding-top: 30px;
		padding-bottom: 20px;
	}

	/* 订单信息头部查看更多 */
	.orderInfoMore {
		color: #0060DD;
		font-size: 14px;
	}

	/* 订单信息头部查看更多图片 */
	.orderInfoMoreImg {
		width: 7px;
		height: 13px;
	}

	/* 第二行开始的行 */
	/* 表格 */
	.oITable {
		border: 1px solid #eee;
		border-right: 0;
	}

	.oITable .tr+.tr .td {
		border-top: 1px solid #eee;
	}

	/* 每一个单元格 */
	.oITable .tr .th,
	.oITable .tr .td {
		flex: 1;
		/* color: #666; */
		font-size: 16px;
		text-align: center;
		border-right: 1px solid #eee;
	}

	/* 表头 */
	.oITable .tr .th {
		line-height: 40px;
		background-color: #E9F3FF;
	}

	/* 表格 */
	.oITable .tr .td {
		line-height: 50px;
	}
</style>
